module.exports = __webpack_public_path__ + "static/liveagent-fa480e3d48a581e0188ce0eeddb84df6.svg";